import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MobipaidPage } from './mobipaid.page';

const routes: Routes = [
  {
    path: '',
    component: MobipaidPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MobipaidPageRoutingModule {}
